import { render, staticRenderFns } from "./DataPull.vue?vue&type=template&id=80b533de&scoped=true&"
import script from "./DataPull.vue?vue&type=script&lang=js&"
export * from "./DataPull.vue?vue&type=script&lang=js&"
import style0 from "./DataPull.vue?vue&type=style&index=0&id=80b533de&lang=less&scoped=true&"
import style1 from "./DataPull.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b533de",
  null
  
)

export default component.exports